import { CommonModule, DatePipe } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, signal, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { AvailabilityComponent } from "../../dialogs/availability/availability.component";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RolesOfUsers } from 'src/app/common/types/common';
import { UserService } from '../user.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { ToastrService } from 'ngx-toastr';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MY_FORMATS } from 'src/app/common/dateFormat';
import { environment } from 'src/environments/environment';
import { WebcamDialogComponent } from '../../dialogs/webcam-dialog/webcam-dialog.component';
import { MatMenuTrigger } from '@angular/material/menu';
import { FallbackImageDirective } from 'src/app/common/directive/fallback-image.directive';
import { CommonDropDown } from 'src/app/common/types/dropdown.type';
import { LookupService } from 'src/app/services/lookup.service';
import { DoctorSpecialityDetailComponent } from '../../settings/hospital-setting/doctor-speciality/doctor-speciality-detail/doctor-speciality-detail.component';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import * as constants from 'src/app/common/constant/constants.type'
import { ValidationService } from 'src/app/common/validation/validation.service';
import { AllowOnlyDigitsDirective } from 'src/app/common/directive/allow-only-digits.directive';
import { IUsers, UserAvailabilityPayload, UserAvalibility } from '../iusers';
import { TranslationUtils } from 'src/app/common/utils/translation.utils';
import { Subject, take, takeUntil } from 'rxjs';
import { DialogUtils } from 'src/app/common/utils/dialog.utils';
import { LoginService } from 'src/app/login.service';
import { MaskInputDirective } from 'src/app/common/directive/mask-input.directive';

@Component({
  selector: 'app-user',
  standalone: true,
  imports: [
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    TablerIconsModule,
    MatFormFieldModule,
    CommonModule,
    AvailabilityComponent,
    MatDatepickerModule,
    TranslateModule,
    FallbackImageDirective,
    AllowOnlyDigitsDirective,
    MaskInputDirective
  ],
  templateUrl: './user-detail.component.html',
  styleUrl: './user-detail.component.scss',
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserDetailComponent implements OnInit, AfterViewInit {

  @ViewChild('availabilityComp') availabilityComp!: AvailabilityComponent;
  userForm: FormGroup;
  imageUrl: string | ArrayBuffer | null = null;
  readonly panelOpenState = signal(false);
  avalibility: UserAvalibility[];
  userAvailabilityPayload: UserAvailabilityPayload;
  minDate: Date;
  maxDate: Date = new Date();
  userRole = RolesOfUsers;
  DoctorSpeciality: CommonDropDown[] = [];
  hidePassword = true;
  userDatafill: IUsers;
  isEdit: boolean;
  selected: Date | null;
  userid: number;
  showAddPhotoOverlay: boolean;
  staticimagepath: string = environment.imagePath;
  defaultAvatarPath = 'assets/images/profile/user-1.jpg';
  Imagefilename: string;
  selectedImage: File | null = null;
  private destroy$ = new Subject<void>();
  hidePan = false;
  hideAadhaar = false;
  isLoading: boolean = false;

  constructor(
    private _formBuilder: FormBuilder,
    private _userservice: UserService,
    private dialogRef: MatDialogRef<UserDetailComponent>,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private translate: TranslateService,
    private dialog: MatDialog,
    private loaderService: LoaderService,
    private translationUtils: TranslationUtils,
    @Inject(MAT_DIALOG_DATA) private _data: { user: IUsers, isEdit: boolean, assistantDoctor?: string },
    private _lookupService: LookupService,
    private dialogUtils: DialogUtils,
    private loginService: LoginService
  ) {
    this.minDate = new Date(1800, 0, 1);
    this.userDatafill = _data?.user;
    this.isEdit = _data?.isEdit;
    this.userid = _data?.user?.id;
  }

  ngOnInit(): void {
    this.userForm = this._formBuilder.group({
      firstname: ['', [ValidationService.nameValidator, Validators.required, Validators.maxLength(20)]],
      lastname: ['', [ValidationService.nameValidator, Validators.required, Validators.maxLength(20)]],
      email: ['', [Validators.required, ValidationService.emailValidator]],
      username: ['', [Validators.required, Validators.minLength(3)]],
      birthDate: ['', [Validators.required]],
      joinDate: ['', [Validators.required]],
      panNumber: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10), ValidationService.panNumberValidator]],
      aadhaarNumber: ['', [Validators.required, Validators.maxLength(12), Validators.minLength(12), ValidationService.aadhaarNumberValidator]],
      address: ['', [Validators.maxLength(255)]],
      password: ['', this.isEdit ? [Validators.minLength(8)] : [Validators.required, Validators.minLength(8)]],
      role: [[], [Validators.required]],
      avatar: [''],
      phoneNumber: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10), ValidationService.phoneNumberValidator]],
      isAutoGeneratePassword: [false],
      specialityId: [''],
      degree: [''],
      registrationNumber: ['']
    });

    this._lookupService.getSpeciality()
      .pipe(
        take(1),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        this.DoctorSpeciality = data;
      })

  }

  ngAfterViewInit(): void {
    if (this._data?.user?.id) {
      this.getUserByid(this._data?.user?.id);
    }
  }

  onFileChanged(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      const file = target.files[0];
      this.Imagefilename = file.name;// name fetch mate chnage if we thing as into file 
      const reader = new FileReader();
      this.selectedImage = file;
      reader.onload = () => {
        this.imageUrl = reader.result;
        this.cdr.detectChanges();
      };
      reader.readAsDataURL(file);
    }
  }

  takePhotoOnWebCamera() {
    this.showAddPhotoOverlay = false;
    const dialogRef = this.dialog.open(WebcamDialogComponent, {
      width: '500px',
      height: 'auto',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result._imageAsDataUrl) {
          this.imageUrl = result._imageAsDataUrl;
          this.Imagefilename = constants.DEFAULT_WEB_CAM_NAME; // Set a default name for the webcam image
          this.selectedImage = this.dataURLtoFile(result._imageAsDataUrl, this.Imagefilename);
          this.cdr.detectChanges();
        }

      }
    });
  }

  dataURLtoFile(dataurl: string, filename: string): File {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)?.[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  onSaveUser() {
    const UserData = this.userForm.getRawValue();
    if (UserData.birthDate && UserData.joinDate) {
      const birthDate = new Date(UserData.birthDate);
      const joinDate = new Date(UserData.joinDate);

      if (joinDate < birthDate) {
        this.toastr.error(this.translate.instant('DATE_COMPARE'));
        return; // Stop submission
      }
      if (birthDate > new Date()) {
        this.toastr.error(this.translate.instant('FUTURE_BIRTHDATE'));
        return;
      }
      if (joinDate > new Date()) {
        this.toastr.error(this.translate.instant('FUTURE_JOINDATE'));
        return;
      }
      UserData.birthDate = this.datePipe.transform(UserData.birthDate, constants.DATE_FORMAT);
      UserData.joinDate = this.datePipe.transform(UserData.joinDate, constants.DATE_FORMAT);
    }

    if (this.isDoctor) {
      const availabilityData = this.availabilityComp.saveDataSlotwise();
      if (!availabilityData || availabilityData.length === 0) {
        this.toastr.error(this.translate.instant('TIME_EMPTY'))
        return; // Stop if validation fails
      }
    }

    if (this.selectedImage != null) {
      UserData.avatar = this.selectedImage
    }

    const formValues = UserData;
    const formData = new FormData();

    Object.keys(formValues).forEach((key) => {
      if (key !== 'role') {
        formData.append(key, formValues[key]);
      }
    });

    const roles = this.userForm.get('role')?.value;
    if (roles) {
      roles.forEach((role: string) => {
        formData.append('roles', role);
      });
    }

    this._userservice.createUser(formData).subscribe((response) => {
      if (response.isSuccess) {
        if (this.isDoctor) {
          this.availabilityComp.saveDataSlotwise();
          const userId = response.result.id;
          const userAvailabilities: UserAvalibility[] = this.avalibility;
          const userAvailabilityData: UserAvailabilityPayload = { userId, userAvailabilities };

          this._userservice.createUserAvalibility(userAvailabilityData).subscribe((res) => {

            if (res.isSuccess) {
              this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.CREATE', this.translate.instant('ENTITY.USERAVAILABILITY')));
              this.dialogUtils.closeSidePanel(this.dialogRef, res);
            } else {
              const allErrors = Object.values(res.errors).flat();
              this.toastr.error(allErrors.join("\n"));
            }
          });
        } else {
          this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.CREATE', this.translate.instant('ENTITY.USER')));
          this.dialogUtils.closeSidePanel(this.dialogRef, response);
        }

      }
      else {
        const allErrors = Object.values(response.errors).flat();
        this.toastr.error(allErrors.join("\n"));
      }
    });

  }

  onUserUpdate() {
    const updateUserData =
    {
      ...this.userForm.getRawValue(),
      id: this._data?.user?.id
    };
    if (updateUserData.birthDate && updateUserData.joinDate) {
      const birthDate = new Date(updateUserData.birthDate);
      const joinDate = new Date(updateUserData.joinDate);

      if (joinDate < birthDate) {
        this.toastr.error(this.translate.instant('DATE_COMPARE'));
        return; // Stop submission
      }
      if (birthDate > new Date()) {
        this.toastr.error(this.translate.instant('FUTURE_BIRTHDATE'));
        return;
      }
      if (joinDate > new Date()) {
        this.toastr.error(this.translate.instant('FUTURE_JOINDATE'));
        return;
      }
      updateUserData.birthDate = this.datePipe.transform(updateUserData.birthDate, constants.DATE_FORMAT);
      updateUserData.joinDate = this.datePipe.transform(updateUserData.joinDate, constants.DATE_FORMAT);
    }
    //emit avalibility

    if (this.isDoctor) {
      const isValid = this.availabilityComp.saveDataSlotwise();
      if (!isValid) {
        this.toastr.error(this.translate.instant('TIME_EMPTY'))
        return; // Stop if validation fails
      }

    }

    const formValues = updateUserData;
    const formData = new FormData();

    Object.keys(formValues).forEach((key) => {
      const value = (formValues as any)[key];
      if (key !== 'role' && value !== null && value !== undefined && value !== '') {
        formData.append(key, value);
      }
    });

    const roles = this.userForm.get('role')?.value;

    if (roles) {
      roles.forEach((role: string) => {
        formData.append('roles', role);
      });
    }

    if (this.selectedImage != null) {
      formData.append("avatar", this.selectedImage);
    } else {
      formData.append("avatar", this._data?.user?.avatar || '');
    }

    this._userservice.updateUsers(formData).subscribe((response) => {
      if (response.isSuccess) {

        if (this.isDoctor) {

          this.availabilityComp.saveDataSlotwise();
          const userId = updateUserData.id;
          const userAvailabilities = this.avalibility;
          const userAvlibilityData: any = { userId, userAvailabilities };
          this._userservice.createUserAvalibility(userAvlibilityData).subscribe((res) => {
            if (res.isSuccess) {
              this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.UPDATE', this.translate.instant('ENTITY.USERAVAILABILITY')));
              this.dialogUtils.closeSidePanel(this.dialogRef, res);
            } else {
              const allErrors = Object.values(res.errors).flat();
              this.toastr.error(allErrors.join("\n"));
            }
          });
        } else {
          this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.UPDATE', this.translate.instant('ENTITY.USER')));
          this.dialogUtils.closeSidePanel(this.dialogRef, response);
        }
      }
      else {
        const allErrors = Object.values(response.errors).flat();
        this.toastr.error(allErrors.join("\n"));
      }
    });
  }

  avalibilityCheck(data: UserAvalibility[]) {
    this.avalibility = data;
  }

  get isDoctor(): boolean {
    const roles = this.userForm.get('role')?.value || [];
    return roles.includes('Doctor') || roles.includes('AsstDoctor');
  }

  get isAdmin(): boolean {
    const userRoles = this.loginService.getUserRoleFromToken();
    return userRoles?.includes('Admin') ?? false;
  }

  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }

  onCloseDialog() {
    this.dialogUtils.closeSidePanel(this.dialogRef);
  }

  onMenuClosed() {
    this.showAddPhotoOverlay = false;
  }

  openMenu(trigger: MatMenuTrigger) {
    trigger.openMenu();
  }

  onAddSpeciality() {
    this.dialog.open(DoctorSpecialityDetailComponent, {
      width: '600px',
      height: 'auto',
    }).afterClosed().subscribe((res) => {
      if (res) {
        this._lookupService.getSpeciality()
          .pipe(
            take(1),
            takeUntil(this.destroy$))
          .subscribe((response) => {
            this.DoctorSpeciality = response;
            this.userForm.get('specialityId')?.setValue(res.result.id);
          });
      }
    });
  }

  getUserByid(id: number) {
    this.isLoading = true;
    this._userservice.getUserByID(id)
      .subscribe({
        next: (response) => {
          const user = response.result;
          this.userForm.patchValue(this.mapUserData(user));

          if (user.avatar) {
            this.imageUrl = environment.imagePath + user.avatar;
            this.userForm.patchValue({ avatar: user.avatar });
          }
          if (user.email) {
            this.userForm.get('email')?.disable();
          }
        },
        error: (err) => {
          console.error(err);
        },
        complete: () => {
          this.isLoading = false;  // stop loader
        }
      });
  }

  private mapUserData(user: IUsers) {
    const roles = user.roleName?.split(',').map((r: string) => r.trim()) || [];
    return {
      firstname: user.firstName || this._data.assistantDoctor,
      lastname: user.lastName,
      email: user.email,
      username: user.userName,
      birthDate: user.birthDate,
      joinDate: user.joinDate,
      panNumber: user.panNumber,
      aadhaarNumber: user.aadhaarNumber,
      address: user.address,
      role: roles,
      phoneNumber: user.phoneNumber,
      specialityId: user.specialityId,
      degree: user.degree,
      registrationNumber: user.registrationNumber
    };
  }
  get avatarSrc(): string {
    if (this.imageUrl) {
      return this.imageUrl as string;
    }
    if (this.userDatafill?.avatar) {
      return this.staticimagepath + this.userDatafill.avatar;
    }
    return this.defaultAvatarPath;
  }
}
